import { Modules } from '@app/core/Enum';
import { OverviewFilterModel } from '@app/core/Models';

export class GetOverviewData {
  static readonly type = '[OVERVIEW] Get Overview Data';
  constructor(public body: OverviewFilterModel, public moduleId: Modules) {}
}
